import { Navigate, useLocation, useParams } from "react-router-dom";

/** SET-1: /c/:slug/reference and /c/:slug/team moved under settings; a bookmark or a ?domain= deep link still lands. */
export const RedirectKeepingSearch = ({ to }: { to: string }) => {
  const { slug = "" } = useParams();
  const { search, hash } = useLocation();
  return <Navigate to={`/c/${slug}/${to}${search}${hash}`} replace />;
};
